import { SettingsState } from '../settings.state';
import * as settings from '../actions/settings.actions';

const initialState: SettingsState = {
    ready: false,
    showFooter: true
};

export const settingsReducer = (state: SettingsState = initialState,
                                action) => {
    switch (action.type) {
        case settings.ActionTypes.SHOW_FOOTER_UPDATE:
            return {...state, showFooter: action.payload};
        case settings.ActionTypes.SET_APP_READY:
            return {...state, ...{ready: true}};
        default:
            return state;
    }
};
